import React from 'react';
import { uniqueId } from 'lodash';

const Sidebar = ({ categories, refs }) => {
  const handleScroll = (category) => {
    const value =
      refs[category].current.getBoundingClientRect().top +
      (window.scrollY - 70);
    window.scrollTo({ top: value, behavior: 'smooth' });
  };

  const handleCategories = () => {
    return categories.map((category) => {
      return (
        <li
          key={uniqueId('category')}
          className='category mb-5'
          onClick={() => handleScroll(category)}
        >
          {category}
        </li>
      );
    });
  };

  return (
    <section className='col-md-3 module'>
      <div>
        <div className='mt-10'>
          <h4 className='mb-10'>Categories</h4>
          {handleCategories()}
        </div>
        <div className='mt-30'>
          <h4>Become a preferred partner</h4>
          <p className='mb-10'>
            Join our preferred partner network and access new opportunities
            first!
          </p>
          <button
            data-tf-popup='lTW4snUe'
            data-tf-opacity='100'
            data-tf-size='70'
            data-tf-iframe-props='title=Voray - Schedule Demo'
            data-tf-auto-close='3000'
            data-tf-transitive-search-params
            data-tf-medium='snippet'
            className='btn-main'
          >
            Apply now
          </button>
        </div>
        <div className='mt-30  mb-10'>
          <h4>Can’t find what you’re looking for?</h4>
          <p className='mb-10'>
            Let us know by requesting a partner. We’ll do our best to make a
            connection!
          </p>
          <button
            data-tf-popup='T4hhFOaK'
            data-tf-opacity='100'
            data-tf-size='70'
            data-tf-iframe-props='title=Voray - Schedule Demo'
            data-tf-auto-close='3000'
            data-tf-transitive-search-params
            data-tf-medium='snippet'
            className='btn-main'
          >
            Submit a request
          </button>
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
